import {QueryClientProvider} from '@tanstack/react-query'
import {useState, type PropsWithChildren} from 'react'
import {criarQueryClient} from './query-client'

export function QueryProvider({children}: PropsWithChildren) {
  const [queryClient] = useState(criarQueryClient)

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
